import { render, staticRenderFns } from "./PrivacyinfoDetail_20250605.vue?vue&type=template&id=26d0e0a7&scoped=true&"
import script from "./PrivacyinfoDetail_20250605.vue?vue&type=script&lang=js&"
export * from "./PrivacyinfoDetail_20250605.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyinfoDetail_20250605.vue?vue&type=style&index=0&id=26d0e0a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d0e0a7",
  null
  
)

/* custom blocks */
import block0 from "./PrivacyinfoDetail_20250605.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports